import GetLabel from "foundation/js/getLabel"
import { ref, computed } from "vue"
import { useStore } from "vuex"

import FormInputTextField from "../FormInputTextField/FormInputTextField"
import FormInputNameField from "../FormInputNameField/FormInputNameField"
import FormAddressField from "../FormAddressField/FormAddressField"
import FormInputEmailField from "../FormInputEmailField/FormInputEmailField"
import FormInputPhoneField from "../FormInputPhoneField/FormInputPhoneField"
import FormCheckbox from "../FormCheckbox/FormCheckbox"
import nameValidator from "foundation/js/inputValidators/nameValidator"
import phoneValidator from "foundation/js/inputValidators/phoneValidator"
import emailValidator from "foundation/js/inputValidators/emailValidator"

export default {
    name: "CreateFrivilligeProfile",
    components: {
        FormInputTextField,
        FormInputNameField,
        FormAddressField,
        FormInputEmailField,
        FormInputPhoneField,
        FormCheckbox
    },
    props: {
        external: {
            type: Object,
            required: true,
        }
    },
    setup(props) {
        const store = useStore()
        const firstName = ref(props.external.userData?.firstName ?? "")
        const lastName = ref(props.external.userData?.lastName ?? "")
        const email = ref(props.external.userData?.email ?? "")
        const phoneNumber = ref(props.external.userData?.phoneNumber ?? "")
        const address = ref(props.external.userData?.address ?? "")
        const postalCode = ref(props.external.userData?.postalCode ?? "")
        const city = ref(props.external.userData?.city ?? "")
        const consentBool = ref(false)
        const newsletterBool = ref(false)
        const displayError = ref(false)
        const isSubmitting = computed(() => store.state.frivilligprofil.submitting)

        const isReadOnly = ref({
            firstName: firstName.value !== "",
            lastName: lastName.value !== "",
            email: email.value !== "",
            phoneNumber: phoneNumber.value !== "",
            address: address.value !== ""
        })

        const addressValidator = (address, postalCode, city) => {
            return address && postalCode && city
        }

        const consentValidator = (consent) => {
            return consent
        }

        const validateFields = () => {
            if (nameValidator(firstName.value) 
                && nameValidator(lastName.value) 
                && phoneValidator(phoneNumber.value) 
                && emailValidator(email.value) 
                && addressValidator(address.value, postalCode.value, city.value)
                && consentValidator(consentBool.value)
            ) {
                return true
            }
            return false
        }

        const submit = async () => {

            if (validateFields()) {
                displayError.value = false
                await store.dispatch("frivilligprofil/createProfil", {
                    pageId: store.state.main.page_id,
                    body: {
                        firstName: firstName.value,
                        lastName: lastName.value,
                        email: email.value,
                        phoneNumber: phoneNumber.value,
                        address: address.value,
                        postalCode: postalCode.value,
                        city: city.value,
                        consentBool: consentBool.value,
                        newsletterBool: newsletterBool.value
                    }
                })
            } else {
                displayError.value = true
            }
        }

        return {
            firstName,
            lastName,
            email,
            phoneNumber,
            address,
            postalCode,
            city,
            consentBool,
            newsletterBool,
            displayError,
            isSubmitting,
            isReadOnly,
            nameValidator,
            phoneValidator,
            emailValidator,
            addressValidator,
            submit,
            getLabel: (labelKey) => GetLabel({ labelKey, labelCollection: "CreateFrivilligprofil" })
        }
        
    }
}